/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { datePickerMinDate, linkPattern, noWhitespaceInRequiredValidator, password_validation, recurringPattern } from '../../../shared/constants';
import { noop } from 'jquery';
import { addDays } from 'date-fns';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'app-recurring-task-form',
	templateUrl: './recurring-task-form.component.html',
	styleUrl: './recurring-task-form.component.scss'
})
export class RecurringTaskFormComponent {
	moduleForm: FormGroup = this.formBuilder.group({
		department_id: [null, [Validators.required]],
		lead_id: [null, [Validators.required]],
		assigned_id: [null, [Validators.required]],
		sub_task: [null, [Validators.required]],
		notes: [null],
		recurrence_pattern: ["D", [Validators.required]],
	});
	showLoader = false;
	pageLoading1 = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	details: any = null;
	/* minDate = datePickerMinDate; */
	userList: any[] = [];
	recurringPattern = recurringPattern;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	initForm(uId: any) {
		this.uId = uId;
		this.apiService.userList$.subscribe((userList) => {
			if (userList) {
				this.userList = userList;
			}
		});
		if (this.uId) {
			this.getDetails();
		} else {
			this.moduleForm.reset();
			this.formSubmitted = false;
			this.uId = null;
		}
	}

	get f() { return this.moduleForm.controls; }

	clearForm() {
		this.uId = null;
		this.moduleForm.reset();
		this.formSubmitted = false;
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getRecTask({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.details = data;
				this.f.department_id.setValue(this.details.department);
				if (this.details.lead) {
					this.navbar.getValueFromUserList(this.details.lead, "id").then((val) => {
						this.f.lead_id.setValue(val);
					});
				}
				if (this.details.assigned) {
					this.navbar.getValueFromUserList(this.details.assigned, "id").then((val) => {
						this.f.assigned_id.setValue(val);
					});
				}
				this.f.sub_task.setValue(this.details.sub_task);
				this.f.notes.setValue(this.details.notes);
				this.f.recurrence_pattern.setValue(this.details.recurrence_pattern);
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
					noop;
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			department_id: this.f.department_id.value,
			lead_id: this.f.lead_id.value,
			assigned_id: this.f.assigned_id.value,
			sub_task: this.f.sub_task.value,
			notes: this.f.notes.value,
			recurrence_pattern: this.f.recurrence_pattern.value
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateRecTask(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
